// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCache } from "../../Commons/DataCache.js";
import { Resources } from "../../Commons/properties/Resources.js";
import { InstrumentUtils } from "../../Utils/Instruments/InstrumentUtils.js";
import { InstrumentTotalInfoTemplate } from "../../templates.js";
import { ControlsTypes } from "../UtilsClasses/FactoryConstants.js";
import { Control } from "./Control.js";

export let InstrumentTotalInfo = Control.extend({
    template: InstrumentTotalInfoTemplate,
    data: function ()
    {
        return {
            instrumentTotalInfo: {
                Quantity: "0",
                AvgPrice: "0",
                PL: "0",
            },
            account: null,
            instrument: null,

            quantityText: 'Quantity:',
            avgPriceText: 'Avg. price:',
            plText: 'P/L:'
        };
    },
    InstrumentForData: null
});

InstrumentTotalInfo.prototype.getType = function () { return ControlsTypes.InstrumentTotalInfo };

InstrumentTotalInfo.prototype.oninit = function ()
{
    Control.prototype.oninit.apply(this);
    Control.Ticker.Subscribe(this.TickAsync, this);
    Resources.onLocaleChange.Subscribe(this.localize, this);
    this.localize();
    this.observe("instrument", this.CorrectingSourceObject)
};

InstrumentTotalInfo.prototype.dispose = function ()
{
    Control.Ticker.UnSubscribe(this.TickAsync, this);
    Resources.onLocaleChange.UnSubscribe(this.localize, this);

    Control.prototype.dispose.apply(this);
};

//TODO fucking shit
InstrumentTotalInfo.prototype.CorrectingSourceObject = function (n, o)
{
    if (n)
        if (!n.IsContiniousContract && n.isFuturesSymbol)
        {
            let x = DataCache.getInstrumentByTradable_ID(n.InstrumentTradableID, n.Route)
            if (x && x.IsContiniousContract && x.isFuturesSymbol)
                this.InstrumentForData = x;
        }
        else
            this.InstrumentForData = n;
}

InstrumentTotalInfo.prototype.TickAsync = function ()
{
    let instrument = this.InstrumentForData;
    let account = this.get("account");

    if (!instrument || !account || instrument.IsEmpty)
        return;

    let positionAmount = 0;
    if (instrument.AccountTotalPositionAmount && instrument.AccountTotalPositionAmount[account.AcctNumber])
        positionAmount = InstrumentUtils.formatAmountValue(instrument.AccountTotalPositionAmount[account.AcctNumber], instrument);

    let averageOpenPrice = 0;
    let AvgPosPriceWithAmount = instrument.GetTotalAveragePositionPriceWithAmount(account);
    if (AvgPosPriceWithAmount)
        averageOpenPrice = instrument.formatPricePrecision(AvgPosPriceWithAmount)

    let pLByCurrency = 0;
    if (instrument.AccountTotalProfitLoss !== null && instrument.AccountTotalProfitLoss[account.AcctNumber] != null)
        pLByCurrency = instrument.roundProfit(instrument.AccountTotalProfitLoss[account.AcctNumber]);

    let instrumentTotalInfo = {
        Quantity: positionAmount || "---",
        AvgPrice: averageOpenPrice || "---",
        PL: pLByCurrency || "---",
    }
    this.set({ instrumentTotalInfo: instrumentTotalInfo });
};

InstrumentTotalInfo.prototype.localize = function ()
{
    this.set({
        quantityText: Resources.getResource('panel.instrumentInfo.Qty'),
        avgPriceText: Resources.getResource('panel.instrumentInfo.AvgPrice'),
        plText: Resources.getResource('panel.instrumentInfo.P/L')
    });
};

InstrumentTotalInfo.prototype.repopulate = function () { };